import { useEffect, useRef } from 'react';
import McomeVideo from '../assets/M_come.mp4';

export default function MComeVideo() {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        video.muted = true;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    video.play().catch(() => {});
                } else {
                    video.pause();
                }
            },
            { threshold: 0.3 }
        );

        observer.observe(video);
        return () => observer.disconnect();
    }, []);

    return (
        <div className='sm:h-[30vh] h-[40vh] flex justify-center items-center relative'>
            <video
                ref={videoRef}
                loop
                muted
                playsInline
                preload="auto"
                className="h-[50%] sm:h-full sm:w-2/5 w-full object-cover "
                style={{ transform: 'scale(1)' }}
                alt="background video">
                <source src={McomeVideo} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
}